<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Part 1: INJUSTICE">
<h1 class="ct" id="d12e663"><a href="#/Hend_ISBN9780785229223_epub_c5_r1#d12e298" id="d12e665"><b>Part 1<br/> <br/> INJUSTICE</b></a></h1>
<p class="extc" id="d12e670"><em>“You have struggled with God </em><em>and with men and have prevailed.”</em></p>
<p class="extc" id="d12e675"><b>—G</b><b>ENESIS </b><b>32:28 </b><b>HCSB</b></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hend_ISBN9780785229223_epub_c10_r1.vue?82ee1d9e